import { React } from 'react';
import { styled } from '@mui/system';
import Loading from '../../../../components/ui/Loading';
import { useGetMatchCafeInfoByInputQuery } from '../../../../store/api/cafeApi';

import { useState, useEffect, useCallback } from 'react';
import DisplayAndPagination from '../DisplayAndPagination/DisplayAndPagination';

const SearchResultDisplay = ({ displayedItems, input, getItemInfo, currentItems, setSkip }) => {
  const lengthPerPage = 8;
  const [page, setPage] = useState(0);
  const [pageForSearchResult, setPageForSearchResult] = useState(0);
  const [next, setNext] = useState(0);

  const handleChange = (e, p) => {
    setPage(p);
    const start = lengthPerPage * (p - 1);
    setSkip(start);
  };

  const handleChangeForSearchResult = (e, p) => {
    setPageForSearchResult(p);
    const start = lengthPerPage * (p - 1);
    setNext(start);
  };

  const limit = 8;
  const { data: matchedCafe, isLoading } = useGetMatchCafeInfoByInputQuery({ input, limit, next });
  if (isLoading) return <Loading />;
  if (!matchedCafe) return <Loading />;

  const pageNumber = Math.ceil(displayedItems.data.cafeLength / lengthPerPage);
  const pageNumberForSearchResult = Math.ceil(matchedCafe.data.cafeLength / lengthPerPage);

  return (
    <>
      {matchedCafe.data.length === 0 ? (
        <DisplayAndPagination
          data={displayedItems.data.cafeList}
          selectedItems={currentItems}
          itemInfo={getItemInfo}
          totalPageNumber={pageNumber}
          page={page}
          onChange={handleChange}
        />
      ) : (
        <DisplayAndPagination
          data={matchedCafe.data.cafeList}
          selectedItems={currentItems}
          itemInfo={getItemInfo}
          totalPageNumber={pageNumberForSearchResult}
          page={pageForSearchResult}
          onChange={handleChangeForSearchResult}
        />
      )}
    </>
  );
};

export default SearchResultDisplay;
